module.exports = __webpack_public_path__ + "static/media/Priest_Healing.c170c437.png";